/** Build-time map settings (`.env`: `VITE_MAP_*`, docs/DEPLOY.md § Kaarttegels). */
export interface MapConfig {
  /** XYZ raster template, e.g. `https://tiles.example.org/styles/basic/{z}/{x}/{y}.png`; empty = no map. */
  tileUrl: string;
  attributionText: string;
  attributionUrl: string;
}

export function mapConfig(): MapConfig {
  const env = import.meta.env;
  return {
    tileUrl: String(env.VITE_MAP_TILE_URL ?? "").trim(),
    attributionText: String(env.VITE_MAP_ATTRIBUTION_TEXT ?? "© OpenStreetMap-bijdragers"),
    attributionUrl: String(env.VITE_MAP_ATTRIBUTION_URL ?? "https://www.openstreetmap.org/copyright"),
  };
}
